/* unplugin-vue-components disabled */import { render } from "./SafeAreaBottom.vue?vue&type=template&id=e4b10bec"
import script from "./SafeAreaBottom.vue?vue&type=script&lang=js"
export * from "./SafeAreaBottom.vue?vue&type=script&lang=js"

import "./SafeAreaBottom.vue?vue&type=style&index=0&id=e4b10bec&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__